import { render, staticRenderFns } from "./Feast.vue?vue&type=template&id=f8ad7e58&scoped=true&"
import script from "./Feast.vue?vue&type=script&lang=js&"
export * from "./Feast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ad7e58",
  null
  
)

/* custom blocks */
import block0 from "./Feast.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports